import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-button"
    }}>{`sp-button`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a button.`}</p>
    <p><img alt="Buttons" src={require("../../assets/sp-button.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/button/"
        }}>{`https://spectrum.adobe.com/page/button/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/button"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/button`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button>Vectorize</sp-button>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`There are several variations that are supported.`}</p>
    <h3 {...{
      "id": "call-to-action"
    }}>{`Call to action`}</h3>
    <p>{`Renders a "call to action"-style button. This is the default variant if no variant is provided.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="cta">Click me</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "primary"
    }}>{`Primary`}</h3>
    <p>{`Renders a "primary" button.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="primary">Click me</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "secondary"
    }}>{`Secondary`}</h3>
    <p>{`Renders a "secondary" button.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="secondary">Click me</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "warning"
    }}>{`Warning`}</h3>
    <p>{`Renders a button intended to be used to indicate negative consequences to the action, such as an action that can't be undone.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Spectrum Web Components now uses a `}<inlineCode parentName="p">{`negative`}</inlineCode>{` variant. This will be addressed in a future update.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="warning">Click me</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "over-background"
    }}>{`Over Background`}</h3>
    <p>{`Renders a button that's suitable over a background (such as an image).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="overBackground">Over an Image</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button disabled>Disabled</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <p>{`Quiet buttons do not have a border, and are less visually distracting.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Quiet buttons do not support the `}<inlineCode parentName="p">{`cta`}</inlineCode>{` variant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button quiet>A quiet button</sp-button>
`}</code></pre>
    <h3 {...{
      "id": "with-icon"
    }}>{`With icon`}</h3>
    <h4 {...{
      "id": "built-in-svg-icon"
    }}>{`Built-in SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button>
    <sp-icon name="ui:Magnifier" size="s" slot="icon"></sp-icon>
    Zoom
</sp-button>
`}</code></pre>
    <h4 {...{
      "id": "custom-svg-icon"
    }}>{`Custom SVG icon`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button>
    <div slot="icon" style="fill: currentColor">
        <svg viewBox="0 0 36 36" style="width: 18px; height: 18px;">
            <path d="M33.567 8.2L27.8 2.432a1.215 1.215 0 0 0-.866-.353H26.9a1.371 1.371 0 0 0-.927.406L5.084 23.372a.99.99 0 0 0-.251.422L2.055 33.1c-.114.377.459.851.783.851a.251.251 0 0 0 .062-.007c.276-.063 7.866-2.344 9.311-2.778a.972.972 0 0 0 .414-.249l20.888-20.889a1.372 1.372 0 0 0 .4-.883 1.221 1.221 0 0 0-.346-.945zM11.4 29.316c-2.161.649-4.862 1.465-6.729 2.022l2.009-6.73z"/>
        </svg>
    </div>
    Edit Text
</sp-button>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to a click on the button using the `}<inlineCode parentName="p">{`click`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourButton").addEventListener("click", evt => {
    console.log("Button clicked");
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      